import ReactDOM from 'react-dom/client';
import App from "./App";
import './i18n';

import './index.scss';
import './portal.css';
import 'antd/dist/antd.css';

import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <App />
);

reportWebVitals();
